import * as SessionManagementChannel from '@tableau/microview-communication-service/lib/src/channelDefinitions/SessionManagementChannelDefinitions';

import {
    getSessionManagementServiceInstance,
    SessionManagementService,
  } from '../../../src/sessionManagement/SessionManagementService';
import { ExtractEncryptionMode } from '../../../src/sites/SitePropertyTypes';


const sessionManagementService: SessionManagementService = getSessionManagementServiceInstance();

export function startListening(): () => void {
    const unsubscribeSessionSiteUrlNameChannel = startListeningToSessionSiteUrlNameChannel();
    const unsubscribeSessionUserIDChannel = startListeningToSessionUserIDChannel();
    const unsubscribeExtractEncryptEnabledChannel = startListeningToExtractEncryptEnabledOmniSwitchChannel();
    const unsubscribeExtractEncryptionModeForSiteChannel = startListeningToExtractEncryptionModeForSiteChannel();
    const unsubscribeCatalogOnsiteEnabledChannel = startListeningToCatalogOnsiteEnabledChannel();

    return () => {
        unsubscribeSessionSiteUrlNameChannel();
        unsubscribeSessionUserIDChannel();
        unsubscribeExtractEncryptEnabledChannel();
        unsubscribeExtractEncryptionModeForSiteChannel();
        unsubscribeCatalogOnsiteEnabledChannel();
    };
}

export function startListeningToSessionSiteUrlNameChannel(): () => void {
    const sessionSiteUrlNameChannel = new SessionManagementChannel.SessionSiteUrlNameChannel();
    return sessionSiteUrlNameChannel.listen(() => {
        return { seassionSiteUrlName: sessionManagementService.sessionSiteUrlName()};
    });
}

export function startListeningToExtractEncryptEnabledOmniSwitchChannel(): () => void {
    const extractEncryptEnabledChannel = new SessionManagementChannel.ExtractEncryptionEnabledOmniSwitchChannel();
    return extractEncryptEnabledChannel.listen(() => {
        return {
            extractEncryptionEnabled: sessionManagementService.isExtractEncryptionEnabledOmniSwitch()
        };
    });
}

export function startListeningToExtractEncryptionModeForSiteChannel(): () => void {
    const extractEncryptionModeForSiteChannel = new SessionManagementChannel.ExtractEncryptionModeForSiteChannel();
    return extractEncryptionModeForSiteChannel.listen(() => {
        const extractEncryptionMode = sessionManagementService.getExtractEncryptionModeForSite();
        return { extractEncryptionMode: mapExtractEncryptionMode(extractEncryptionMode) };
    });
}

export function startListeningToCatalogOnsiteEnabledChannel(): () => void {
    const catalogOnsiteEnabledChannel = new SessionManagementChannel.CatalogOnsiteEnabledChannel();
    return catalogOnsiteEnabledChannel.listen(() => {
        return { catalogOnsiteEnabled : sessionManagementService.catalogingOnSiteEnabled()};
    });
}

export function startListeningToSessionUserIDChannel(): () => void {
    const sessionUserIDChannel = new SessionManagementChannel.SessionUserIDChannel();
    return  sessionUserIDChannel.listen(() => {
        return { sessionUserId: sessionManagementService.sessionUserId()};
    });
}

/* 
    This function maps the VPC's ExtractEncryptionMode to the communication channel's 
    ExtractEncryptionMode (SessionManagement.ExtractEncryptionMode) 
*/

function mapExtractEncryptionMode(vpcExtractMode: ExtractEncryptionMode): SessionManagementChannel.ExtractEncryptionMode{
    switch(vpcExtractMode){
        case ExtractEncryptionMode.DISABLED:
            return SessionManagementChannel.ExtractEncryptionMode.DISABLED;
        case ExtractEncryptionMode.ENABLED:
            return SessionManagementChannel.ExtractEncryptionMode.ENABLED;
        case ExtractEncryptionMode.ENFORCED:
            return SessionManagementChannel.ExtractEncryptionMode.ENFORCED;
    }
}
